<template>
  <div class="anz-align-center">
    <div
      class="anz-inline-flex anz-align-items-center"
      :class="containerClassName"
    >
      <div
        class="anz-spinner"
        :class="[className, { 'anz-spinner-block': block }]"
      ></div>
      <template v-if="title.length > 0">
        <div class="anz-ml-m">
          {{ title }}
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ALoader',
  props: {
    className: {
      type: String,
    },
    containerClassName: {
      type: String,
    },
    block: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
})
</script>
